// A little scatter of stones — so even a single tile reads as a rocky clump.
// Ported 1:1 from age-of-mcp's classic rocks.ts, restoring its scatter loop.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const spots: Array<[number, number, number, number]> = [
    [0, 0, 0.2, 0],          // x, z, r, colorIdx
    [0.26, 0.1, 0.13, 1],
    [-0.2, 0.16, 0.11, 2],
    [0.08, -0.24, 0.09, 1],
  ];
  const cols = ["#7c7f86", "#6e7178", "#888b91"];
  const parts: Part[] = [];
  for (const [sx, sz, r, ci] of spots) {
    parts.push({
      geometry: new THREE.IcosahedronGeometry(r, 0),
      color: cols[ci]!,
      position: [sx, r * 0.7, sz],
      scale: [1.1, 0.8, 1],
    });
  }
  return parts;
}

export const rocks = defineModel({
  id: "rocks",
  batchId: "standard",
  name: "Rocks",
  tags: ["scenery","rocks","low-poly","age-of-mcp","classic"],
  summary: "Low-poly rocks.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.46,
  parts: () => partsFor(),
  animations: [],
});
